import { ColumnType } from 'antd/es/table'

import { NomenclatureType } from '@/types'

export default function getTableSelectedCellsRange(
  data: NomenclatureType[],
  columns: ColumnType<NomenclatureType>[],
  startCell: { rowKey: string; columnKey: string },
  endCell: { rowKey: string; columnKey: string }
) {
  const selectedCells: { rowKey: string; columnKey: string }[] = []

  const startRowIndex = data.findIndex((row) => row.key === startCell.rowKey)
  const endRowIndex = data.findIndex((row) => row.key === endCell.rowKey)

  const startColumnIndex = columns.findIndex(
    (column) => column.key === startCell.columnKey
  )
  const endColumnIndex = columns.findIndex(
    (column) => column.key === endCell.columnKey
  )

  const minRowIndex = Math.min(startRowIndex, endRowIndex)
  const maxRowIndex = Math.max(startRowIndex, endRowIndex)
  const minColumnIndex = Math.min(startColumnIndex, endColumnIndex)
  const maxColumnIndex = Math.max(startColumnIndex, endColumnIndex)

  for (let rowIndex = minRowIndex; rowIndex <= maxRowIndex; rowIndex++) {
    for (
      let columnIndex = minColumnIndex;
      columnIndex <= maxColumnIndex;
      columnIndex++
    ) {
      const rowKey = data[rowIndex].key
      const columnKey = columns[columnIndex].key
      if (columnKey) {
        selectedCells.push({
          rowKey: String(rowKey),
          columnKey: String(columnKey),
        })
      }
    }
  }

  return selectedCells
}

// export default function getTableSelectedCellsRange(
//   data: NomenclatureType[],
//   columnsKeys: string[],
//   startCell: { rowKey: string; columnKey: string },
//   endCell: { rowKey: string; columnKey: string }
// ) {
//   const selectedCells: { rowKey: string; columnKey: string }[] = []

//   const startRowIndex = data.findIndex((row) => row.key === startCell.rowKey)
//   const endRowIndex = data.findIndex((row) => row.key === endCell.rowKey)

//   const startColumnIndex = columnsKeys.findIndex(
//     (columnKey) => columnKey === startCell.columnKey
//   )
//   const endColumnIndex = columnsKeys.findIndex(
//     (columnKey) => columnKey === endCell.columnKey
//   )

//   const minRowIndex = Math.min(startRowIndex, endRowIndex)
//   const maxRowIndex = Math.max(startRowIndex, endRowIndex)
//   const minColumnIndex = Math.min(startColumnIndex, endColumnIndex)
//   const maxColumnIndex = Math.max(startColumnIndex, endColumnIndex)

//   for (let rowIndex = minRowIndex; rowIndex <= maxRowIndex; rowIndex++) {
//     for (
//       let columnIndex = minColumnIndex;
//       columnIndex <= maxColumnIndex;
//       columnIndex++
//     ) {
//       const rowKey = data[rowIndex].key
//       const columnKey = columnsKeys[columnIndex]
//       if (columnKey) {
//         selectedCells.push({
//           rowKey: String(rowKey),
//           columnKey: String(columnKey),
//         })
//       }
//     }
//   }

//   return selectedCells
// }
